export const azimuthAddress = '0x223c067F8CF28ae173EE5CafEa60cA44C335fecB';
export const eclipticAddress = '0x33EeCbf908478C10614626A9D304bfe18B78DD73';
export const wstrAddress = '0xF0dC76C22139ab22618dDFb498BE1283254612B1';
export const treasuryAddress = '0x3e1efda147ec9309e1e47782ecafede1d04b45e5';
export const poolAddress = '0x7f4a0822A6E3c085df795a8d78ACBcD36F210ebf';
export const wethAddress = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2';
export const wstrFlashSwapAddress = '0x295b94088C897f1b81b92F77130Be69fF3257A9C';
export const quoterAddress = '0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6';
